import React from 'react';

const ProductsSkeleton: React.FC = () => {
  return (
    <div className="card animate-pulse">
      <div className="card-header">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-neutral-200 rounded-xl"></div>
            <div>
              <div className="w-40 h-5 bg-neutral-200 rounded mb-2"></div>
              <div className="w-48 h-4 bg-neutral-200 rounded"></div>
            </div>
          </div>
          <div className="w-16 h-4 bg-neutral-200 rounded"></div>
        </div>
      </div>
      
      <div className="card-body">
        <div className="space-y-4">
          {[1, 2, 3, 4].map((item) => (
            <div key={item} className="p-4 rounded-xl border-b border-neutral-100 last:border-b-0">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  {/* Ranking skeleton */}
                  <div className="w-8 h-8 bg-neutral-200 rounded-full"></div>
                  
                  {/* Informações do produto skeleton */}
                  <div className="flex-1">
                    <div className="w-32 h-4 bg-neutral-200 rounded mb-2"></div>
                    <div className="flex items-center space-x-3">
                      <div className="w-20 h-4 bg-neutral-200 rounded"></div>
                      <div className="flex items-center space-x-1">
                        <div className="w-4 h-4 bg-neutral-200 rounded"></div>
                        <div className="w-8 h-3 bg-neutral-200 rounded"></div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Badge skeleton */}
                <div className="w-24 h-6 bg-neutral-200 rounded-full"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsSkeleton; 